<template>
  <div>
    <el-container>
      <el-main class="myArticles">
        <div class="home-search-wrap">
          <el-input
            v-model="searchKeyword"
            placeholder="输入文章标题关键词"
            class="home-search-input"
            clearable
            @keyup.enter.native="doSearch"
          />
          <el-button type="primary" class="home-search-btn" @click="doSearch">搜索</el-button>
          <el-button class="home-search-reset" @click="resetSearch">重置</el-button>
        </div>

        <ArticleScrollPage :query="articleQuery"></ArticleScrollPage>
        <ai-assistant-widget></ai-assistant-widget>
      </el-main>

      <el-aside>
        <mine></mine>
        <article-tag :tags="hotTags"></article-tag>
        <article-card cardHeader="最热文章" :articles="hotArticles" itemStyle=""></article-card>
        <article-card cardHeader="最新文章" :articles="newArticles" itemStyle=""></article-card>
        <archive-card cardHeader="文章归档" :archives="archives"></archive-card>
      </el-aside>
    </el-container>
  </div>
</template>

<script>
import ArticleScrollPage from "@/components/common/ArticleScrollPage"
import Mine from "@/components/card/Mine"
import ArticleTag from "@/components/card/ArticleTag"
import ArticleCard from "@/components/card/ArticleCard"
import ArchiveCard from "@/components/card/ArchiveCard"
import AiAssistantWidget from "@/components/chat/AiAssistantWidget"

import { getHotArticles, getNewArticles, getArchives } from "@/api/article"
import { getHotTags } from "@/api/tag"
import { getToken } from "@/request/token"
import { Message } from "element-ui"

export default {
  name: "HomePage",
  components: {
    ArticleScrollPage,
    mine: Mine,
    "article-tag": ArticleTag,
    "article-card": ArticleCard,
    "archive-card": ArchiveCard,
    "ai-assistant-widget": AiAssistantWidget
  },
  data() {
    return {
      searchKeyword: "",
      articleQuery: {},
      hotTags: [],
      hotArticles: [],
      newArticles: [],
      archives: []
    }
  },
  created() {
    if (this.checkLogin()) {
      this.getHotTags()
      this.getHotArticles()
      this.getNewArticles()
      this.getArchives()
    }
  },
  methods: {
    checkLogin() {
      if (!getToken()) {
        Message({
          type: "warning",
          showClose: true,
          message: "请先登录"
        })
        this.$router.push({ path: "/login" })
        return false
      }
      return true
    },
    getHotTags() {
      getHotTags().then((res) => {
        if (res.data.success) this.hotTags = res.data.data
        else this.$message.error(res.data.msg)
      }).catch(() => this.$message.error("获取热门标签失败"))
    },
    getHotArticles() {
      getHotArticles().then((res) => {
        if (res.data.success) this.hotArticles = res.data.data
        else this.$message.error(res.data.msg)
      }).catch(() => this.$message.error("获取最热文章失败"))
    },
    getNewArticles() {
      getNewArticles().then((res) => {
        if (res.data.success) this.newArticles = res.data.data
        else this.$message.error(res.data.msg)
      }).catch(() => this.$message.error("获取最新文章失败"))
    },
    getArchives() {
      getArchives().then((res) => {
        if (res.data.success) this.archives = res.data.data
        else this.$message.error(res.data.msg)
      }).catch(() => this.$message.error("获取文章归档失败"))
    },
    doSearch() {
      const kw = this.searchKeyword ? this.searchKeyword.trim() : ""
      this.articleQuery = kw ? { title: kw } : {}
    },
    resetSearch() {
      this.searchKeyword = ""
      this.articleQuery = {}
    }
  }
}
</script>

<style scoped>
.el-container {
  width: 1080px;
  max-width: 90vw;
  margin: 0 auto;
}

.el-aside {
  margin-left: 40px;
  width: 280px;
}

.el-main {
  position: relative;
  padding: 0;
  line-height: 1.6;
}

.home-search-wrap {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
  padding: 14px 18px;
  background: rgba(10, 15, 28, 0.5);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid rgba(0, 255, 245, 0.2);
  border-radius: 12px;
  box-sizing: border-box;
  max-width: 100%;
}

.home-search-input {
  flex: 1;
  min-width: 0;
}

.home-search-input :deep(.el-input__inner) {
  background: rgba(0, 255, 245, 0.06) !important;
  border-color: rgba(0, 255, 245, 0.3) !important;
  color: rgba(224, 242, 254, 0.95) !important;
}

.home-search-input :deep(.el-input__inner::placeholder) {
  color: rgba(148, 163, 184, 0.8);
}

.home-search-input :deep(.el-input__inner:hover),
.home-search-input :deep(.el-input__inner:focus) {
  border-color: rgba(0, 255, 245, 0.6) !important;
}

.home-search-btn {
  flex-shrink: 0;
  background: rgba(0, 255, 245, 0.2) !important;
  border-color: rgba(0, 255, 245, 0.5) !important;
  color: #00fff5 !important;
}

.home-search-btn:hover {
  background: rgba(0, 255, 245, 0.35) !important;
  border-color: #00fff5 !important;
  color: #fff !important;
}

.home-search-reset {
  flex-shrink: 0;
  background: transparent !important;
  border-color: rgba(148, 163, 184, 0.5) !important;
  color: rgba(203, 213, 225, 0.9) !important;
}

.home-search-reset:hover {
  border-color: rgba(0, 255, 245, 0.5) !important;
  color: #00fff5 !important;
}

.el-card {
  border-radius: var(--radius-md);
  border: none;
  background: var(--bg-card);
  box-shadow: var(--shadow-card);
  transition: all 0.3s ease;
}

.el-card:hover {
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.06), 0 4px 12px rgba(0, 0, 0, 0.04);
  transform: translateY(-1px);
}

.el-card:not(:first-child) {
  margin-top: 24px;
}

@media (max-width: 1024px) {
  .el-container {
    width: 95vw;
  }

  .el-aside {
    margin-left: 24px;
    width: 240px;
  }
}

@media (max-width: 768px) {
  .el-aside {
    display: none;
  }
}
</style>
